// HeaderUser
// ログイン済みユーザー用ヘッダー
// ------------------------------
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import UserInfoModal from '../UserInfoModal/UserInfoModal'
import FloatingSupportChat from '../../containers/FloatingSupportChatContainer'

// Import Scss
import './HeaderUser.scss'

// Import Image
import logo from '../../images/logo.png'
import logoFwd from '../../images/logo-fwd.png'
import profileMale from '../../images/default-account-profile.png'
import profileFemale from '../../images/default-account-profile-female.png'
import freecallBanner from '../../images/freedial.svg'
import freecallBannerFwd from '../../images/freedial-fwd.svg'
import freecallBannerFree from '../../images/freedial-free.svg'

class HeaderUser extends Component {
  constructor(props) {
    super(props)
    this.setWrapperRefListMenu = this.setWrapperRefListMenu.bind(this)
    this.handleClickOutsideHeadMenu = this.handleClickOutsideHeadMenu.bind(this)
    this.touchEvent = 'ontouchend' in window ? 'touchend' : 'click'
  }
  componentDidMount() {
    document.addEventListener(this.touchEvent, this.handleClickOutsideHeadMenu)
  }
  componentWillUnmount() {
    document.removeEventListener(this.touchEvent, this.handleClickOutsideHeadMenu)
  }

  setWrapperRefListMenu(node) {
    this.wrapperRefListMenu = node
  }

  handleClickOutsideHeadMenu(event) {
    if (this.wrapperRefListMenu && !this.wrapperRefListMenu.contains(event.target) && this.props.openMobileMenu) {
      this.props.toggleMobileMenu()
    }
  }

  render() {
    const profileImg = this.props.gender === "female" ? profileFemale : profileMale
    const menuStateClass = this.props.openMobileMenu === true ? " open" : ""
    const hideInfoClass = this.props.hideInfo ? " hide-info" : ""

    let findmeLogo = (
      <div className="logo-wrapper">
        <Link to="/">
          <img src={logo} alt='Findme' />
          <small>がん専門医師からのセカンドオピニオン</small>
        </Link>
      </div>
    )
    let freecall = (
      <a href="tel:0120227810">
        <img src={freecallBanner} alt="お困りの際はお電話ください 0120-227-810 受付時間 平日 10:00-17:00"/>
      </a>
    )
    let faqLink = process.env.REACT_APP_HOME + "/faq/"

    if(this.props.campaign === 'FWD') {
      findmeLogo = (
        <div className="logo-wrapper fwd">
          <Link to="/">
            <img src={logoFwd} alt='Findme F' />
          </Link>
        </div>
      )
      freecall = (
        <a href="tel:0120308297">
          <img src={freecallBannerFwd} alt="お困りの際はお電話ください 0120-308-297 受付時間 平日 10:00-17:00"/>
        </a>
      )
      faqLink = process.env.REACT_APP_HOME + "/fwdlife/faq/"
    }
    if(this.props.campaign === 'AFLAC') {
      findmeLogo = (
        <div className="logo-wrapper">
          <Link to="/">
            <img src={logo} alt='Findme' />
          </Link>
        </div>
      )
      freecall = (
        <a href="tel:0120668608">
          <img src={freecallBannerFree} alt="お困りの際はお電話ください 0120-668-608 受付時間 平日 10:00-17:00"/>
        </a>
      )
      faqLink = process.env.REACT_APP_HOME + "/so/free/faq/"
    }
    return (
      <div className="header-user">
        <header className={`header${menuStateClass}${hideInfoClass}`} ref={this.setWrapperRefListMenu}>
          {!this.props.hideInfo &&
            <div onClick={this.props.toggleUserInfoModal} className="profile-wrapper">
              <img src={profileImg} alt="プロフィール"/>
            </div>
          }
          {findmeLogo}
          {this.props.hideInfo && !this.props.hideChat &&
            <FloatingSupportChat chatroomId={this.props.chatroomId} />
          }
          <div className="hamburger-wrapper" onClick={this.props.toggleMobileMenu}>
            <div className="hamburger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <ul className="list-menu">
            <li className="list-menu__faq">
              <a href={faqLink}>
                <span className="icon icon-qa"></span>
                よくある質問
              </a>
            </li>
            <li className="list-banner">
              {freecall}
            </li>
            <li>
              <Link to="/logout" className="btn-main-outline">
                <span className="icon icon-logout"></span>
                ログアウト
              </Link>
            </li>
          </ul>
        </header>
        <UserInfoModal {...this.props}/>
      </div>
    )
  }
}

export default HeaderUser



// WEBPACK FOOTER //
// ./src/components/HeaderUser/HeaderUser.js